import React, {FC, useEffect} from 'react';

import {ErrorLayoutType} from 'common/constants';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {ErrorContextProvider} from 'ui/contexts/Error';
import getSurveyPath from 'ui/utils/getSurveyPath';

import Error from '../Error';
import Layout from '../Layout';
import SuccessPage from '../SuccessPage';
import SurveyPage from '../SurveyPage';

const {basePath, iframe} = window.YC;

const iframeBodyClassName = 'iframe';

const App: FC = () => {
    useEffect(() => {
        if (iframe && !document.body.classList.contains(iframeBodyClassName)) {
            document.body.classList.add(iframeBodyClassName);
        }
    }, []);

    return (
        <Layout>
            <ErrorContextProvider>
                <BrowserRouter basename={basePath}>
                    <Routes>
                        <Route path={getSurveyPath()} element={<SurveyPage />} />
                        <Route path={getSurveyPath({path: 'success'})} element={<SuccessPage />} />
                        <Route path="*" element={<Error error={ErrorLayoutType.NotFound} />} />
                    </Routes>
                </BrowserRouter>
            </ErrorContextProvider>
        </Layout>
    );
};

export default App;
